import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { Icon } from '@hotelplan/components.common.icon';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';

const LegendContainer = styled.div(
  sx2CssThemeFn(({ theme: { space } }) => ({
    marginTop: space[2],
  }))
);

const TripLegendsWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: ['column', 'row'],
    flexFlow: ['column', 'wrap'],
  })
);

const TripLegend = styled.div(
  sx2CssThemeFn(({ theme: { colors } }) => ({
    display: 'flex',
    flexDirection: 'row',
    marginRight: [3],
    marginTop: [2],
    '.icon': {
      marginRight: [2],
      height: '30px',
      minWidth: ['30px', 'auto'],
      color: colors.redWeb,
      '&.new-roundtrip': {
        color: colors.redWeb,
      },
      '&.old-roundtrip': {
        color: colors.blueOcean,
      },
    },
  }))
);

const FdrGeoTripsLegend: React.FC = () => {
  const [t, { language }] = useTranslation('geo');
  return (
    <LegendContainer>
      <TripLegendsWrapper>
        <TripLegend>
          <Icon size="xlg" name="white-border-cluster-icon" />
          <span>{t('map.legend.cluster')}</span>
        </TripLegend>
        <TripLegend>
          <Icon size="lg" name="map-pin-roundtrips" className="new-roundtrip" />
          <span>{t('map.legend.products')}</span>
        </TripLegend>
        {language === 'de' ? (
          <TripLegend>
            <Icon
              size="lg"
              name="map-pin-roundtrips"
              className="old-roundtrip"
            />
            <span>{t('map.legend.roundtrips')}</span>
          </TripLegend>
        ) : null}
      </TripLegendsWrapper>
    </LegendContainer>
  );
};

export default FdrGeoTripsLegend;
